import React, { ChangeEvent, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { consoleLogInDev, track } from 'shared';
import Calendar from './Calendar/Calendar';
import { Colors, OutlinedDropdown, ToggleButtons } from 'library';
import { Link } from 'react-router-dom';
import ShiftList from './Shifts/ShiftList';
import JobPostsList from './JobPosts/JobPostsList';
import BusinessCalendar from './BusinessCalendar/BusinessCalendar';
import { IBusinessLocation } from 'models';
import { getBusinessLocations } from 'api/BusinessLocationApi';
import DraftList from './Drafts/DraftList';

const FAM_TABS = ['Calendar View', 'Card View'];
const BIZ_TABS = ['Calendar', 'Active Jobs', 'Drafts'];

const JobCardList = ({ isBusiness }: { isBusiness: boolean }) => {
    const defaultTab = isBusiness ? BIZ_TABS[0] : FAM_TABS[0];
    const [selectedTab, setSelectedTab] = useState(defaultTab);
    const [businessLocations, setBusinessLocations] = useState<IBusinessLocation[]>([]);
    const [selectedLocation, setSelectedLocation] = useState<IBusinessLocation>();

    function toggleView(tab: string) {
        setSelectedTab(tab);
        track('Upcoming Job Screen Toggled', { selectedScreen: tab });
    }

    useEffect(() => {
        fetchBusinessLocations();
    }, []);

    function fetchBusinessLocations() {
        getBusinessLocations()
            .then((result) => {
                const paramLocation = new URLSearchParams(window.location.search).get('location');
                const location = result.results.find((l: IBusinessLocation) => l.id === parseInt(paramLocation || ''));
                setSelectedLocation(location ?? result.results[0]);
                setBusinessLocations(result.results);
            })
            .catch((error) => {
                consoleLogInDev(error);
            });
    }

    function handleLocationChange(e: ChangeEvent<{ name?: string; value: string | any }>) {
        const location = businessLocations.find((b) => b.id.toString() === e.target.value);
        const newLocation = location ?? businessLocations[0];
        setSelectedLocation(newLocation);
    }

    function tabFactory(tab: string) {
        const commonProps = { addressId: selectedLocation?.address.id };
        switch (tab) {
            case 'Active Jobs':
            case 'Card View':
                return isBusiness ? <ShiftList {...commonProps} /> : <JobPostsList />;
            case 'Drafts':
                return <DraftList />;
            default:
                return isBusiness ? <BusinessCalendar {...commonProps} /> : <Calendar />;
        }
    }

    const tabsOptions = isBusiness ? BIZ_TABS : FAM_TABS;

    return (
        <Grid container>
            <Grid style={{ marginTop: 20, paddingRight: 20 }} item container justify="space-between">
                <Grid item container xs={12} md={4}>
                    <ToggleButtons tabs={tabsOptions} onTabSelect={toggleView} selectedTab={selectedTab} />
                </Grid>
                <Grid item container xs={12} md={4} justify="center" style={{ margin: '15px 0' }}>
                    {isBusiness ? (
                        <OutlinedDropdown
                            value={selectedLocation?.id.toString() || ''}
                            fields={businessLocations.map((b) => {
                                return { key: b.id.toString(), value: b.name };
                            })}
                            onChange={handleLocationChange}
                        />
                    ) : null}
                </Grid>
                <Grid item container xs={12} md={4} justify="center">
                    <Link style={{ color: Colors.darkNavy, textDecorationLine: 'underline' }} to="confirm-hours">
                        View all reported timesheets
                    </Link>
                </Grid>
            </Grid>
            <Grid container direction="row" style={{ marginTop: 10 }} xs={12}>
                {tabFactory(selectedTab)}
            </Grid>
        </Grid>
    );
};

export default JobCardList;
